'use client';

import React, { useContext, useMemo, createContext } from 'react';
import useGetSubFolders from '@/components/hooks/use-get-sub-folders';
import type {
  FloorPlansProviderState,
  FloorPlansProviderProperties,
} from './types';

const INITIAL_PROVIDER_STATE: FloorPlansProviderState = {
  folderError: null,
  folders: [],
  imageUrlErrors: null,
  images: {},
  isLoading: true,
};

const FloorPlansStateContext = createContext(INITIAL_PROVIDER_STATE);

export function useFloorPlansState() {
  return useContext(FloorPlansStateContext);
}

function FloorPlansProvider({ children }: FloorPlansProviderProperties) {
  const getSubFoldersQuery = useGetSubFolders({ path: 'floor-plans' });

  const context = useMemo(
    () => ({
      folderError: getSubFoldersQuery.error?.message ?? null,
      folders: getSubFoldersQuery.data,
      imageUrlErrors: null,
      images: {},
      isLoading: getSubFoldersQuery.isLoading,
    }),
    [
      getSubFoldersQuery.data,
      getSubFoldersQuery.error,
      getSubFoldersQuery.isLoading,
    ],
  );

  return (
    <FloorPlansStateContext.Provider value={context}>
      {children}
    </FloorPlansStateContext.Provider>
  );
}

export default FloorPlansProvider;
